/* global growtype_post */

/**
 * Post CTA
 */
export function postCta(wrapper) {
    initActionBtns();

    document.addEventListener('growtypePostAjaxLoadContent', function (event) {
        initActionBtns();
    })

    document.addEventListener('growtypePostAjaxLoadMoreContent', function (params) {
        likeActionInit($(params.detail.wrapper).find('.growtype-post-btn-like'));
        sharePostAction($(params.detail.wrapper).find('.growtype-post-btn-share'));
    })

    function initActionBtns() {
        /**
         * Like post
         */
        likeActionInit($(wrapper).find('.growtype-post-btn-like'));
        sharePostAction($(wrapper).find('.growtype-post-btn-share'))
    }

    function likeActionInit(element) {
        element.each(function (index, element) {
            if ($(element).attr('data-loaded') === 'true') {
                return;
            }

            $(element).attr('data-loaded', true);

            likeAction($(element))
        })
    }

    function likeAction(element) {
        element.off('click.growtypePostLike').on('click.growtypePostLike', function (event) {
            let btn = $(this);
            let link = btn.find('a');

            if (btn.attr('data-type') === undefined && (link.attr('data-type') === undefined || (link.attr('href') !== undefined && link.attr('href').length > 0))) {
                return;
            }

            event.preventDefault();

            if (btn.hasClass('is-active') && btn.closest('.growtype-post-liked-posts-container-wrapper').length > 0) {
                btn.closest('.growtype-post-single').fadeOut();
            }

            $(this).toggleClass('is-active');

            let dataType = link !== undefined ? link.attr('data-type') : btn.attr('data-type');
            let postId = btn.attr('data-id') !== undefined ? btn.attr('data-id') : growtype_post.post_id;

            jQuery.ajax({
                url: growtype_post.ajax_url,
                type: 'post',
                data: {
                    action: 'growtype_post_like_post',
                    nonce: growtype_post.nonce,
                    post_id: postId,
                    data_type: dataType
                },
                success: function (response) {
                    btn.find('.e-amount').remove();

                    if (response.data['likes'] > 0) {
                        btn.prepend('<span class="e-amount">' + response.data['likes'] + '</span>');
                    }
                }
            });
        })
    }

    /**
     * Share post
     */
    function sharePostAction(element) {
        element.each(function () {
            let shareButton = $(this);

            if (!shareButton.is('button')) {
                shareButton.attr({
                    role: 'button',
                    tabindex: '0',
                    'aria-haspopup': 'dialog',
                    'aria-expanded': 'false'
                });
            }
        });

        element.off('click.growtypePostShare').on('click.growtypePostShare', function (event) {
            event.preventDefault();
            openShareSheet($(this));
        });

        element.off('keydown.growtypePostShare').on('keydown.growtypePostShare', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                $(this).trigger('click');
            }
        });
    }

    let activeShareTrigger = null;
    let shareSheetCloseTimer = null;

    function shareLabels() {
        let labels = growtype_post.share_labels || {};

        return {
            eyebrow: labels.eyebrow || 'Share',
            title: labels.title || 'Share this post',
            copyLink: labels.copy_link || 'Copy link',
            copied: labels.copied || 'Copied',
            moreApps: labels.more_apps || 'More apps',
            close: labels.close || 'Close share options',
            url: labels.url || 'Post URL'
        };
    }

    function shareServices(url, title) {
        let encodedUrl = encodeURIComponent(url);
        let encodedTitle = encodeURIComponent(title);
        let encodedMessage = encodeURIComponent(title + ' ' + url);

        return [
            {name: 'Facebook', mark: 'f', url: 'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl},
            {name: 'X', mark: 'X', url: 'https://twitter.com/intent/tweet?url=' + encodedUrl + '&text=' + encodedTitle},
            {name: 'WhatsApp', mark: 'WA', url: 'https://wa.me/?text=' + encodedMessage},
            {name: 'Telegram', mark: 'TG', url: 'https://t.me/share/url?url=' + encodedUrl + '&text=' + encodedTitle},
            {name: 'LinkedIn', mark: 'in', url: 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodedUrl},
            {name: 'Reddit', mark: 'R', url: 'https://www.reddit.com/submit?url=' + encodedUrl + '&title=' + encodedTitle},
            {name: 'Email', mark: '@', url: 'mailto:?subject=' + encodedTitle + '&body=' + encodedMessage, sameWindow: true}
        ];
    }

    function getShareSheet() {
        let shareSheet = $('.growtype-post-share-sheet');

        if (shareSheet.length > 0) {
            return shareSheet;
        }

        let labels = shareLabels();

        shareSheet = $('<div class="growtype-post-share-sheet" hidden></div>');
        shareSheet.append($('<button type="button" class="growtype-post-share-sheet__backdrop" tabindex="-1"></button>').attr('aria-label', labels.close));

        let dialog = $('<section class="growtype-post-share-sheet__dialog" role="dialog" aria-modal="true" aria-labelledby="growtype-post-share-sheet-title" tabindex="-1"></section>');
        let header = $('<div class="growtype-post-share-sheet__header"></div>');
        let heading = $('<div></div>');
        heading.append($('<p class="growtype-post-share-sheet__eyebrow"></p>').text(labels.eyebrow));
        heading.append($('<h2 class="growtype-post-share-sheet__title" id="growtype-post-share-sheet-title"></h2>').text(labels.title));
        header.append(heading);
        header.append($('<button type="button" class="growtype-post-share-sheet__close" aria-label=""></button>').attr('aria-label', labels.close).text('×'));
        dialog.append(header);
        dialog.append('<div class="growtype-post-share-sheet__services"></div>');

        let copyRow = $('<div class="growtype-post-share-sheet__copy-row"></div>');
        copyRow.append($('<input type="text" class="growtype-post-share-sheet__url" readonly>').attr('aria-label', labels.url));
        copyRow.append($('<button type="button" class="growtype-post-share-sheet__copy"></button>').text(labels.copyLink));
        dialog.append(copyRow);
        shareSheet.append(dialog);
        $('body').append(shareSheet);

        shareSheet.on('click.growtypePostShareSheet', '.growtype-post-share-sheet__backdrop, .growtype-post-share-sheet__close', closeShareSheet);
        shareSheet.on('click.growtypePostShareSheet', '.growtype-post-share-sheet__service-link', closeShareSheet);
        shareSheet.on('click.growtypePostShareSheet', '.growtype-post-share-sheet__copy', copyShareUrl);
        shareSheet.on('click.growtypePostShareSheet', '.growtype-post-share-sheet__service-native', nativeShare);

        $(document).off('keydown.growtypePostShareSheet').on('keydown.growtypePostShareSheet', function (event) {
            if (shareSheet.prop('hidden')) {
                return;
            }

            if (event.key === 'Escape') {
                event.preventDefault();
                closeShareSheet();
                return;
            }

            if (event.key !== 'Tab') {
                return;
            }

            let focusable = shareSheet.find('a[href], button:not([disabled]), input:not([disabled])').filter(':visible');
            let first = focusable.first()[0];
            let last = focusable.last()[0];

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        });

        return shareSheet;
    }

    function openShareSheet(trigger) {
        let shareSheet = getShareSheet();
        let url = trigger.attr('data-url') || window.location.href;
        let title = trigger.attr('data-title') || document.title;
        let services = shareSheet.find('.growtype-post-share-sheet__services').empty();

        if (typeof navigator.share === 'function') {
            services.append(createShareService({
                name: shareLabels().moreApps,
                mark: '···',
                native: true
            }));
        }

        shareServices(url, title).forEach(function (service) {
            services.append(createShareService(service));
        });

        shareSheet.attr({'data-url': url, 'data-title': title});
        shareSheet.find('.growtype-post-share-sheet__url').val(url);
        shareSheet.find('.growtype-post-share-sheet__copy').removeClass('is-copied').text(shareLabels().copyLink);

        activeShareTrigger = trigger;
        activeShareTrigger.addClass('is-active').attr('aria-expanded', 'true');
        $('body').addClass('growtype-post-share-sheet-open');
        clearTimeout(shareSheetCloseTimer);
        shareSheet.prop('hidden', false);

        window.requestAnimationFrame(function () {
            shareSheet.addClass('is-open');
            shareSheet.find('.growtype-post-share-sheet__dialog').trigger('focus');
        });
    }

    function createShareService(service) {
        let item;

        if (service.native) {
            item = $('<button type="button" class="growtype-post-share-sheet__service growtype-post-share-sheet__service-native"></button>');
        } else {
            item = $('<a class="growtype-post-share-sheet__service growtype-post-share-sheet__service-link"></a>');
            item.attr('href', service.url);

            if (!service.sameWindow) {
                item.attr({target: '_blank', rel: 'noopener noreferrer'});
            }
        }

        item.append($('<span class="growtype-post-share-sheet__service-mark" aria-hidden="true"></span>').text(service.mark));
        item.append($('<span></span>').text(service.name));

        return item;
    }

    function closeShareSheet() {
        let shareSheet = getShareSheet();
        shareSheet.removeClass('is-open');
        $('body').removeClass('growtype-post-share-sheet-open');

        if (activeShareTrigger) {
            activeShareTrigger.removeClass('is-active').attr('aria-expanded', 'false').trigger('focus');
            activeShareTrigger = null;
        }

        clearTimeout(shareSheetCloseTimer);
        shareSheetCloseTimer = setTimeout(function () {
            shareSheet.prop('hidden', true);
        }, 170);
    }

    function copyShareUrl() {
        let shareSheet = getShareSheet();
        let url = shareSheet.attr('data-url');
        let copyButton = shareSheet.find('.growtype-post-share-sheet__copy');
        let copyPromise;

        if (navigator.clipboard && window.isSecureContext) {
            copyPromise = navigator.clipboard.writeText(url);
        } else {
            let input = shareSheet.find('.growtype-post-share-sheet__url');
            input.trigger('focus').trigger('select');
            copyPromise = document.execCommand('copy') ? Promise.resolve() : Promise.reject();
        }

        copyPromise.then(function () {
            copyButton.addClass('is-copied').text(shareLabels().copied);
            setTimeout(function () {
                copyButton.removeClass('is-copied').text(shareLabels().copyLink);
            }, 1800);
        }).catch(function () {
            shareSheet.find('.growtype-post-share-sheet__url').trigger('focus').trigger('select');
        });
    }

    function nativeShare() {
        let shareSheet = getShareSheet();

        navigator.share({
            title: shareSheet.attr('data-title'),
            url: shareSheet.attr('data-url')
        }).then(closeShareSheet).catch(function (error) {
            if (error.name !== 'AbortError') {
                shareSheet.find('.growtype-post-share-sheet__url').trigger('focus').trigger('select');
            }
        });
    }
}
